<div class="card purchase-card">
  <img class="img-fluid" src="assets/images/dashboard/purchase.png" alt="vector mens with leptop" />
  <div class="card-body pt-3">
    <h6 class="mb-3">{{ 'Buy ' | translate }}<a href="#">{{ 'Pro Account ' | translate }}</a>{{ 'to Explore Primium Features' | translate }}</h6>
    <a class="purchase-btn btn btn-primary btn-hover-effect f-w-500" href="https://1.envato.market/3GVzd" target="_blank">{{ 'Purchase Now' | translate }}</a>
  </div>
</div>
